import * as React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import { trackEvent } from '../../../../libs/analytics'
import buildSearchParams from '../../../../helpers/build-search-params'
import { getLocationFilterLabel } from '../../../../models/LocationFilter'

import { Container, Intro, SearchWrapper } from './style'
import SearchForm from './components/search-form'

import { H1 } from '../../../../ui/landing-page-headings'
import LandingPageBlockWrapper from '../../../../ui/landing-page-block-wrapper'
import formatSimpleMarkdown from '../../../../helpers/format-simple-markdown'
import useOptions from '../../../../hooks/useOptions'

const HeaderMainSearchBlock = React.memo(({ title = '', intro = '', theme, anchorId = '' }) => {
  const history = useHistory()
  const { eventTypes } = useOptions()
  const [eventType, setEventType] = React.useState('')
  const [location, setLocation] = React.useState(null)

  const handleEventTypeChange = e => {
    setEventType(e.currentTarget.value)
    trackEvent('landingpage', 'landingpage-block-header-changed-event-type', e.currentTarget.value)
  }

  const handlePerformLocationChange = match => {
    setLocation(match)
    trackEvent(
      'landingpage',
      'landingpage-block-header-changed-perform-location',
      getLocationFilterLabel(match),
    )
  }

  const handlePerformLocationReset = () => {
    setLocation(null)
  }

  const handleSubmitSearch = () => {
    history.push(`/s${buildSearchParams(eventType, location)}`)
    trackEvent('landingpage', 'landingpage-block-header-submitted-search', 'Søk', {
      eventType,
      location: getLocationFilterLabel(location),
    })
  }
  return (
    <LandingPageBlockWrapper theme={theme} anchorId={anchorId}>
      <Container>
        {title ? <H1 dangerouslySetInnerHTML={{ __html: formatSimpleMarkdown(title) }} /> : null}
        {intro ? <Intro>{intro}</Intro> : null}
        <SearchWrapper>
          <SearchForm
            eventType={eventType}
            eventTypes={eventTypes}
            onEventTypeChange={handleEventTypeChange}
            performLocation={location}
            onPerformLocationChange={handlePerformLocationChange}
            onPerformLocationReset={handlePerformLocationReset}
            onSubmitSearch={handleSubmitSearch}
          />
        </SearchWrapper>
      </Container>
    </LandingPageBlockWrapper>
  )
})

HeaderMainSearchBlock.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.string.isRequired,
  anchorId: PropTypes.string,
  intro: PropTypes.string,
}

export default HeaderMainSearchBlock
